import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import "@/assets/css/reset.css"


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)


//bus中央事件总线
import Bus from './bus'
Vue.prototype.$bus = Bus

//sign
import makeSign  from "@/getSign";
Vue.prototype.$makeSign = makeSign

import "mint-ui/lib/style.css";

// import local from "@/utils/local";
// import { getUrlKey } from "@/utils/getUrlKey";

// import { CheckToken } from "@/api/account";

// console.log(getUrlKey("token"));
// if (getUrlKey("token")) {
//   local.set("t_k", getUrlKey("token"));
//   var url = window.location.href; //获取当前页面的url
//   if (url.indexOf("?") != -1) {
//     //判断是否存在参数
//     url = url.replace(/(\?|#)[^'"]*/, ""); //去除参数
//     window.history.pushState({}, 0, url);
//   }
// }

/* 路由守卫 */
// router.beforeEach((to, from, next) => {
//   /* 
//     to: 【你要去的目标路由对象】
//     from: 【你离开的路由对象】
//     next： 走吧 放行 【是个函数】
//   */


//   if (to.path == '/over' && from.path !== '/index') {
//     next({
//       path: "/index",
//     });
//   } 

//   if(to.path !== "/login"){
//     func.check_token(next);
//   }else{
//     next();
//   }

// });
// var func = {
//     async check_token(next) {
//         let { code, msg, data } = await CheckToken();
//         if(code == "0" && data.error_code == "NSA_00003"){
//             next({
//                 path: "/login",
//             }); // 否则 去的就是别的页面 重置到登录
//         }else{
//           next();
//         }
//     }
// }


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')